<div class="max-w-[1280px] mx-auto px-4 sm:px-6 md:px-8 py-4 h-screen pt-4 pb-4" id="inbox-view-root">
  <div class="loader-overlay flex justify-center py-10" *ngIf="loading">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <ng-container *ngIf="!loading">
    <div
      class="bg-white rounded-3xl border border-primary/5 shadow-sm overflow-hidden h-[calc(100vh-10rem)] min-h-[500px]"
      id="inbox-panel-root">
      <div class="grid grid-cols-1 md:grid-cols-12 h-full min-h-0">

        <!-- Left conversations selection panel - col 4 -->
        <div class="md:col-span-4 border-r border-neutral-200 flex flex-col h-full bg-white relative z-20 chat-inbox-panel"
  [ngClass]="currentReceiverId ? 'mobile-hide-panel' : 'mobile-show-panel'">
          <div class="p-5 border-b border-neutral-100 flex items-center justify-between">
            <!-- Back Button -->
    <button
      type="button"
      class="back-btn"
      (click)="goBack()"
      aria-label="Go back">

      <span class="material-symbols-outlined">
        arrow_back
      </span>

    </button>
            <h3 class="font-display font-bold text-xl text-primary m-0">Inbox</h3>
            <span
              class="material-symbols-outlined text-secondary hover:text-primary cursor-pointer transition-colors text-xl">edit_square</span>
          </div>

          <div class="flex-1 overflow-y-auto divide-y divide-secondary/5 no-scrollbar">

            <div *ngIf="uniqueChatList.length === 0" class="p-8 text-center text-secondary text-xs">
              No active conversations yet. Start messaging connections from your dashboard!
            </div>

            <div *ngFor="let c of sortedUniqueChatList" (click)="selectConversation(c._id)"
              class="p-3 mx-3 my-1.5 rounded-[18px] flex items-center gap-3.5 cursor-pointer transition-all relative"
              [ngClass]="c._id === currentReceiverId ? 'bg-primary/10' : (getUnreadCount(c._id) > 0 ? 'bg-primary/5 hover:bg-primary/10' : 'hover:bg-neutral-50 bg-transparent')">
              <!-- Portrait circular -->
              <div class="relative shrink-0">
                <ng-container *ngIf="base64Images[c._id]; else defaultAvatarList">
                  <img [src]="'data:image/jpeg;base64,' + base64Images[c._id]"
                    class="h-12 w-12 rounded-full object-cover ring-2"
                    [ngClass]="c._id === currentReceiverId ? 'ring-primary/20' : 'ring-primary/5'" />
                </ng-container>
                <ng-template #defaultAvatarList>
                  <div
                    class="h-12 w-12 rounded-full flex items-center justify-center ring-2"
                    [ngClass]="c._id === currentReceiverId ? 'bg-primary/10 text-primary ring-primary/20' : 'bg-surface-container-low text-on-surface-variant/30 ring-primary/5'">
                    <span class="material-symbols-outlined text-lg">person</span>
                  </div>
                </ng-template>
                <div *ngIf="isOnline(c._id)" 
                  class="absolute bottom-0 right-0 h-3.5 w-3.5 bg-emerald-500 border-2 border-white rounded-full z-10 shadow-sm">
                </div>
              </div>

              <!-- Text details -->
              <div class="flex-1 min-w-0">
                <div class="flex justify-between items-baseline mb-0.5">
                  <h4 class="font-display font-bold text-base truncate max-w-[120px] m-0"
                    [ngClass]="c._id === currentReceiverId ? 'text-primary' : 'text-neutral-800'">
                    {{ c.basic_info.first_name }} {{ c.basic_info.last_name }}
                  </h4>
                  <span class="text-[11px] font-mono leading-none m-0" 
                    [ngClass]="c._id === currentReceiverId ? 'text-primary/70' : 'text-secondary'" *ngIf="getLastMessageTime(c._id)">
                    {{ getLastMessageTime(c._id) }}
                  </span>
                </div>
                <p class="text-[13px] truncate m-0 mt-0.5"
                  [ngClass]="c._id === currentReceiverId ? 'text-primary/80 font-medium' : (getUnreadCount(c._id) > 0 ? 'text-neutral-900 font-bold' : 'text-neutral-500')">
                  {{ getLastMessage(c._id) }}
                </p>
              </div>

              <!-- Badge -->
              <span *ngIf="getUnreadCount(c._id) > 0"
                class="shrink-0 text-[10px] font-bold h-5 min-w-[20px] px-1 rounded-full flex items-center justify-center shadow-sm"
                [ngClass]="c._id === currentReceiverId ? 'bg-primary text-white' : 'bg-primary text-white'">
                {{ getUnreadCount(c._id) }}
              </span>

            </div>
          </div>
        </div>

        <!-- Right Active Message Window - col 8 -->
        <div class="md:col-span-8 flex flex-col h-full min-h-0 bg-[#f4f2f0] relative chat-window-panel"
  [ngClass]="currentReceiverId ? 'mobile-show-panel' : 'mobile-hide-panel'">

          <div *ngIf="!currentReceiverId"
            class="flex-1 flex flex-col items-center justify-center text-secondary p-8 text-center bg-transparent">
            <div class="h-16 w-16 bg-primary-fixed/40 rounded-full flex items-center justify-center text-primary mb-4">
              <span class="material-symbols-outlined text-3xl">forum</span>
            </div>
            <h4 class="font-display font-bold text-lg text-primary m-0">Select a Conversation</h4>
            <p class="text-xs mt-2">Choose a profile from the left menu to start discussing your future.</p>
          </div>

          <ng-container *ngIf="currentReceiverId">
            <!-- Channel Header -->
            <div
  class="p-3 sm:p-4 px-4 sm:px-6 border-b border-secondary/10 bg-white shadow-sm relative z-20 flex items-center justify-between">

  <!-- Mobile Back Button -->
  <div class="flex items-center gap-2 min-w-0">

    <button
      type="button"
      (click)="backToInbox()"
      class="mobile-chat-back flex items-center justify-center h-9 w-9 rounded-full border-0 bg-primary/5 text-primary hover:bg-primary/10 transition-all cursor-pointer shrink-0"
      aria-label="Back to inbox"
    >
      <span class="material-symbols-outlined text-[20px]">arrow_back</span>
    </button>

    
              <div class="flex items-center gap-3">
                <ng-container *ngIf="base64Images[currentReceiverId]; else defaultAvatarHeader">
                  <img [src]="'data:image/jpeg;base64,' + base64Images[currentReceiverId]"
                    [routerLink]="['/profile-details', currentReceiverId]"
                    class="h-10 w-10 rounded-full object-cover cursor-pointer hover:opacity-80 transition-opacity" />
                </ng-container>
                <ng-template #defaultAvatarHeader>
                  <div
                    [routerLink]="['/profile-details', currentReceiverId]"
                    class="h-10 w-10 rounded-full bg-surface-container-low flex items-center justify-center text-on-surface-variant/30 cursor-pointer hover:opacity-80 transition-opacity">
                    <span class="material-symbols-outlined text-lg">person</span>
                  </div>
                </ng-template>

                <div>
                  <h4 [routerLink]="['/profile-details', currentReceiverId]"
                      class="font-display font-bold text-md text-primary flex items-center gap-1 m-0 cursor-pointer hover:underline">
                    {{ getActivePartnerName() }}
                    <span *ngIf="isPartnerVerified()" class="material-symbols-outlined text-[14px] fill-icon text-emerald-500">verified</span>
                  </h4>
                  <p class="text-[11px] text-secondary flex items-center gap-1.5 leading-none mt-1 m-0">
                    <ng-container *ngIf="isOnline(currentReceiverId); else offlineStatusHeader">
                      <span class="h-2 w-2 rounded-full bg-emerald-500 shadow-[0_0_0_2px_rgba(16,185,129,0.2)] animate-pulse"></span>
                      <span class="font-medium text-emerald-600">Online Now</span>
                    </ng-container>
                    <ng-template #offlineStatusHeader>
                      <span class="font-medium text-neutral-500">{{ timeAgo(currentReceiverId) === 'Unknown' ? 'Offline' : 'Last seen ' + timeAgo(currentReceiverId) }}</span>
                    </ng-template>
                  </p>
                </div>
              </div>
              </div>
              <!-- Quick interactive media triggers -->
              <div class="flex items-center space-x-2">
                <button (click)="handleShareHoroscope()"
                  class="p-2 text-primary hover:bg-primary-fixed/30 rounded-xl transition-all border-0 bg-transparent"
                  title="Share Star Alignment Kundli">
                  <span class="material-symbols-outlined text-lg">star</span>
                </button>
                <button (click)="handleSimulateCall()"
                  class="p-2 text-primary hover:bg-primary-fixed/30 rounded-xl transition-all border-0 bg-transparent"
                  title="Initiate Secure Dialogue">
                  <span class="material-symbols-outlined text-lg">call</span>
                </button>
              </div>
            </div>

            <!-- Chat Bubble stream -->
            <div #chatContainer class="flex-1 min-h-0 p-6 overflow-y-auto space-y-6 bg-transparent"
              style="scroll-behavior: smooth;">

              <!-- Privacy guidance box -->
              <div class="flex justify-center my-4 relative z-10">
                <div
                  class="bg-white/80 backdrop-blur-md px-4 py-1.5 rounded-full border border-neutral-200/60 shadow-sm text-[10px] text-neutral-500 font-medium flex items-center gap-1.5">
                  <span class="material-symbols-outlined text-[12px] text-primary/60">shield_lock</span>
                  Exclusive connection active. Verify background parameters inside Her Details screen.
                </div>
              </div>

              <div *ngIf="isConversationEmpty && !isChatRestricted"
                class="flex flex-col items-center justify-center h-full text-secondary text-sm my-8 space-y-3 opacity-60">
                <span class="material-symbols-outlined text-4xl mb-2">waving_hand</span>
                Say hi and start your conversation with {{ getActivePartnerName() }}!
              </div>

              <div *ngIf="isChatRestricted"
                class="flex flex-col items-center justify-center h-full text-center my-12 space-y-4 p-8 max-w-md mx-auto bg-white/80 backdrop-blur-md rounded-3xl border border-rose-200 shadow-sm">
                <div class="h-16 w-16 bg-gradient-to-br from-rose-500 to-primary rounded-full flex items-center justify-center text-white shadow-lg shadow-rose-500/20 mb-2">
                  <span class="material-symbols-outlined text-3xl">lock_person</span>
                </div>
                <h4 class="font-display font-bold text-lg text-neutral-900 m-0">Conversation Locked</h4>
                <p class="text-xs text-neutral-600 leading-relaxed m-0">
                  Direct messaging with <b>{{ getActivePartnerName() }}</b> is currently restricted because both profiles are on the Free tier.
                </p>
                <div class="pt-2">
                  <button (click)="openUpgradeModal()"
                    class="px-6 py-3 bg-primary hover:bg-primary-container text-white rounded-xl text-xs font-bold shadow-md shadow-primary/20 transition-all cursor-pointer border-0 flex items-center gap-2">
                    <span class="material-symbols-outlined text-base">workspace_premium</span>
                    Upgrade Membership to Unlock Chat
                  </button>
                </div>
              </div>

              <ng-container *ngIf="!isChatRestricted && conversationsMap[currentReceiverId]">
                <div *ngFor="let m of conversationsMap[currentReceiverId].messages" class="flex"
                  [ngClass]="m.sender_id === currentSenderId ? 'justify-end' : 'justify-start'">
                  <!-- Portrait left-align if them -->
                  <ng-container *ngIf="m.sender_id !== currentSenderId">
                    <img *ngIf="base64Images[currentReceiverId]"
                      [src]="'data:image/jpeg;base64,' + base64Images[currentReceiverId]"
                      class="h-8 w-8 rounded-full object-cover mr-3 mt-auto shadow-sm ring-2 ring-white" />
                    <div *ngIf="!base64Images[currentReceiverId]"
                      class="h-8 w-8 rounded-full bg-surface-container-low flex items-center justify-center text-on-surface-variant/30 mr-3 mt-auto shadow-sm ring-2 ring-white">
                      <span class="material-symbols-outlined text-[12px]">person</span>
                    </div>
                  </ng-container>

                  <div class="max-w-[70%] space-y-1.5">
                    <div class="p-3.5 px-4 rounded-[22px] text-[14px] leading-relaxed shadow-sm text-left relative"
                      [ngClass]="m.sender_id === currentSenderId ? 'bg-primary text-white rounded-br-sm shadow-primary/20' : 'bg-white text-neutral-800 border border-neutral-100 rounded-bl-sm'">
                      {{ m.content }}
                    </div>
                    <div class="text-[10px] text-neutral-500 font-medium px-1 m-0 flex items-center gap-1"
                      [ngClass]="m.sender_id === currentSenderId ? 'justify-end' : 'justify-start'">
                      {{ formatTime(m.timestamp) }}
                      <span *ngIf="m.sender_id === currentSenderId"
                        class="material-symbols-outlined text-[13px]"
                        [ngClass]="m.message_subject === 'Read' ? 'text-emerald-500' : 'text-neutral-300'">
                        {{ !m.message_subject ? 'done' : 'done_all' }}
                      </span>
                    </div>
                  </div>

                </div>
              </ng-container>

              <!-- Dynamic Partner Typing indicator bubble -->
              <div *ngIf="isTyping && !isChatRestricted" class="flex justify-start items-center">
                <img *ngIf="base64Images[currentReceiverId]"
                  [src]="'data:image/jpeg;base64,' + base64Images[currentReceiverId]"
                  class="h-7 w-7 rounded-full object-cover mr-2 shadow-sm" />
                <div *ngIf="!base64Images[currentReceiverId]"
                  class="h-7 w-7 rounded-full bg-surface-container-low flex items-center justify-center text-on-surface-variant/30 mr-2 shadow-sm">
                  <span class="material-symbols-outlined text-[10px]">person</span>
                </div>
                <div
                  class="bg-white border border-neutral-100 p-3 rounded-2xl rounded-bl-none shadow-sm flex items-center space-x-1">
                  <div class="h-1.5 w-1.5 rounded-full bg-secondary animate-bounce" style="animation-delay: 0ms"></div>
                  <div class="h-1.5 w-1.5 rounded-full bg-secondary animate-bounce" style="animation-delay: 150ms">
                  </div>
                  <div class="h-1.5 w-1.5 rounded-full bg-secondary animate-bounce" style="animation-delay: 300ms">
                  </div>
                </div>
              </div>

              <div #messagesEnd></div>
            </div>

            <!-- Chat typing form Footer -->
            <form *ngIf="!isChatRestricted" (submit)="handleSend($event)"
              class="p-4 bg-[#f4f2f0] border-t border-neutral-200 relative z-20 flex items-center gap-3">

              <!-- Quick Helper prompts toggles -->
              <!-- ... commented out prompts ... -->

              <div class="flex-1 relative">
                <input type="text" [(ngModel)]="inputText" name="inputText" placeholder="Type a message..."
                  class="w-full bg-white border-0 shadow-sm rounded-full pl-6 pr-12 py-3.5 text-sm focus:ring-2 focus:ring-primary/20 outline-none transition-all placeholder:text-neutral-400 m-0" />
              </div>

              <button type="submit" [disabled]="!inputText.trim()"
                class="h-12 w-12 rounded-full flex items-center justify-center shrink-0 transition-all border-0 m-0 shadow-sm"
                [ngClass]="inputText.trim() ? 'bg-primary text-white hover:bg-primary-container shadow-primary/30 active:scale-95 cursor-pointer' : 'bg-neutral-200 text-neutral-400 cursor-not-allowed'">
                <span class="material-symbols-outlined text-[18px]">send</span>
              </button>
            </form>

            <!-- Locked Chat Footer Banner -->
            <div *ngIf="isChatRestricted"
              class="p-4 bg-neutral-900 border-t border-neutral-800 relative z-20 flex items-center justify-between gap-4 text-white">
              <div class="flex items-center gap-3">
                <div class="h-10 w-10 rounded-full bg-rose-500/20 flex items-center justify-center text-rose-400 shrink-0">
                  <span class="material-symbols-outlined text-xl">lock</span>
                </div>
                <div>
                  <h5 class="text-sm font-bold m-0 text-rose-200 flex items-center gap-1.5">
                    Chat Unavailable
                  </h5>
                  <p class="text-xs text-neutral-400 m-0 mt-0.5">
                    Direct messaging is locked while both members are on the Free plan.
                  </p>
                </div>
              </div>
              <button (click)="openUpgradeModal()"
                class="px-5 py-2.5 bg-gradient-to-r from-rose-700 to-primary hover:from-rose-600 hover:to-primary-container text-white rounded-xl text-xs font-bold shadow-md transition-all shrink-0 cursor-pointer border-0">
                Upgrade to Chat
              </button>
            </div>

          </ng-container>

        </div>

      </div>
    </div>
  </ng-container>
</div>